import { createContext, useContext } from 'react';

// Create the context
import { jsx as _jsx } from "react/jsx-runtime";
const MoltenContext = /*#__PURE__*/createContext();

// Create the provider component
export function MoltenProvider({
  children,
  molten
}) {
  return /*#__PURE__*/_jsx(MoltenContext.Provider, {
    value: molten,
    children: children
  });
}

// Custom hook to use the Molten context
export function useMolten() {
  return useContext(MoltenContext);
}
export function withMolten(Component) {
  return function MoltenedComponent(props) {
    return /*#__PURE__*/_jsx(MoltenContext.Consumer, {
      children: molten => /*#__PURE__*/_jsx(Component, {
        ...props,
        molten: molten
      })
    });
  };
}
export default {
  id: 'molten.MoltenProvider',
  sort: -999,
  createProvider: (molten, children) => {
    return /*#__PURE__*/_jsx(MoltenProvider, {
      molten: molten,
      children: children
    });
  }
};